// extracted by mini-css-extract-plugin
export default {"contentCard":"CardFunction_contentCard__W6P3z"};